import { FETCH_USER, HYDRATE_AUTH, SET_LOADING, CLEAR_AUTH } from '../actions/types';

const initialState = {
    user: null,
    loading: false,
    hydrated: false
};

const authReducer = function(state = initialState, action) {
    switch(action.type) {
        case HYDRATE_AUTH:
            return {
                ...state,
                user: action.payload,
                hydrated: true,
                loading: false
            };
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_USER: 
            return {
                ...state,
                user: action.payload || null,
                loading: false,
                hydrated: true
            };
        case CLEAR_AUTH:
            return {
                ...initialState,
                hydrated: true
            };
        default:
            return state;
    }
};

export default authReducer;